import { useState } from "react";
import FinanceDashboard from "@/components/FinanceDashboard";
import TreasuryHero from "@/components/TreasuryHero";

export default function TresoreriePage() {
  const [detail, setDetail] = useState(false);
  return (
    <div className="max-w-2xl mx-auto px-4 py-6 pb-28 space-y-4">
      <TreasuryHero showDetail={detail} onToggleDetail={() => setDetail((d) => !d)} />
      {detail && <div className="klt-fade-up" data-testid="treso-detail"><FinanceDashboard /></div>}
    </div>
  );
}
